import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthFacade } from "@core/auth";
import { catchError, throwError } from "rxjs";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authFacade = inject(AuthFacade);

  const credentialReq = req.clone({
    withCredentials: true
  });
  
  return next(credentialReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.warn('Session expired or unauthorized. Logging out...');
        authFacade.logout();
      }

      return throwError(() => error);
    })
  );
};